import { useEffect, useState } from "react";
import UserService from "../../services/UserService";
import UserCard from "../UserComponents/UserCard";
import Pagination from "../CommonComponents/Pagination";
import ProfileModal from "../UserComponents/ProfileModal";
import Spinner from "../CommonComponents/Spinner";

function UsersGrid() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedUser, setSelectedUser] = useState(null);

    const fetchUsers = async (page) => {
        setLoading(true);
        try {
            const data = await UserService.getUsers(page, 10);
            setUsers(data.content || []);
            setTotalPages(data.totalPages || 1);
        } catch (err) {
            setError(err.message || "Greška kod dohvaćanja korisnika");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers(currentPage);
    }, [currentPage]);

    if (loading) return <Spinner />
    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", height: "fit-content" }}>
            {users.map((user) => (
                <UserCard
                    key={user.id}
                    user={user}
                    onClick={() => setSelectedUser(user.username)}
                />
            ))}

            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => {
                    setCurrentPage(page);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }}
            />

            {selectedUser && (
                <ProfileModal
                    username={selectedUser}
                    onClose={() => setSelectedUser(null)}
                />
            )}
        </div>
    );
}

export default UsersGrid;
